import { flatten } from 'lodash'
import types from './types'

export default {
  [types.getters.postIDLocale]: (state) => (postID) => {
    if (!postID) return null
    if (!state.postIDs['nl'][postID] && !state.postIDs['fr'][postID]) return null
    if ((state.postIDs['nl'][postID] || 0).toString() === postID) return 'nl'
    if ((state.postIDs['fr'][postID] || 0).toString() === postID) return 'fr'
    return 'nl'
  },
  [types.getters.translatePostID]: (state, getters, rootState) => (postID) => {
    if (!postID) return postID
    return (state.postIDs[rootState.user.locale][postID] || postID).toString()
  },
  [types.getters.allTranslationsPostIDs]: (state, getters, rootState) => (postIDs) => {
    var locales = ['nl', 'fr']
    var t = (locale, postID) => (state.postIDs[locale][postID] || postID).toString()
    return flatten(flatten([postIDs]).map(postID => locales.map(locale => t(locale, postID))))
  }
}
